import { useState } from "react";
import { useLocation } from "react-router-dom";
import { LifeBuoy, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

// Floating "Report an Issue" on every portal page; admin reviews under Activity → Issues.
export const ReportIssue = () => {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/issues", { description: text, page: `${loc.pathname}${loc.search}` });
      toast.success("Thanks — your issue was sent to Admin");
      setText(""); setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't send"); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="report-issue-btn"
        className="fixed bottom-6 left-5 md:left-[17.25rem] z-40 h-11 px-4 rounded-full bg-card border border-border shadow-md text-sm inline-flex items-center gap-2 hover:bg-secondary transition-colors">
        <LifeBuoy className="h-4 w-4 text-[hsl(var(--primary))]" /> Report an Issue
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/30 flex items-end sm:items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="luxury-card w-full max-w-md p-6 bg-card" onClick={(e) => e.stopPropagation()} data-testid="report-issue-dialog">
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-display text-xl font-medium">Report an Issue</h2>
              <button onClick={() => setOpen(false)} aria-label="Close" data-testid="report-issue-close"><X className="h-4 w-4" /></button>
            </div>
            <p className="text-xs text-muted-foreground mb-3">Describe what went wrong. Your name, location, this page and the time are attached automatically.</p>
            <textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} data-testid="report-issue-text"
              className="w-full rounded-xl border border-input bg-card px-3 py-2 text-sm" placeholder="What happened?" />
            <button onClick={send} disabled={busy || text.trim().length < 3} data-testid="report-issue-submit"
              className="mt-3 h-11 w-full rounded-xl bg-foreground text-background text-sm font-medium disabled:opacity-40">
              {busy ? "Sending…" : "Send to Admin"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
